import { Box, Divider, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTemplateShippingProfiles } from "@services/template";
import { useContainer, useTemplate } from "containers/templateDetail/store";
import head from "lodash/head";
import * as React from "react";
import CategoryBreadcrumbs from "./categoryBreadcrumbs";
import ImagePreview from "./imagePreview";
import ProductDetail from "./productDetail";
import ProductTabs from "./productTabs";
import RelatedTemplate from "./relatedTemplate";
import Reviews from "./reviews";

type Props = {
  template: any;
};

export const Container = styled("div")<{ size?: "lg" | "xl" }>(
  ({ theme, size = "xl" }) => ({
    maxWidth:
      size === "lg" ? theme.breakpoints.values.lg : theme.breakpoints.values.xl,
    marginLeft: "auto",
    marginRight: "auto",
    // paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  })
);

export default function TemplateDetail({}): React.ReactElement {
  const template = useTemplate();
  const { data: shippingProfiles } = useTemplateShippingProfiles({
    id: template.id,
  });
  useContainer.activeShippingRate(template.shipping_rates[0]);
  useContainer.activeCountryCode("US");
  useContainer.isSwitchModalOpen(false);
  useContainer.isBigOrderInquireModelOpen(false);
  useContainer.activeShippingProfileID(head(shippingProfiles).id);

  return (
    <React.Fragment>
      <Container size="xl">
        <CategoryBreadcrumbs />
        <Grid container spacing={2} columnSpacing={3}>
          <Grid item xs={12} sm={6} md={7}>
            <Box
              sx={
                {
                  // maxWidth: 700,
                }
              }
            >
              <ImagePreview />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={5}>
            <ProductDetail />
          </Grid>
        </Grid>
      </Container>
      <Box sx={{ mt: 6 }}>
        <ProductTabs />
      </Box>
      <Divider />
      <Reviews />
      <RelatedTemplate />
    </React.Fragment>
  );
}
